import * as sit from './config.sit';
import * as pre from './config.pre';
import * as pre2 from './config.pre2';
import * as prd from './config.prd';
import { isBrowser } from '@/utils';

let config;

const hostname = window.location.hostname;
if (isBrowser()) {
  if (hostname.includes('pplp.suning.com')) {
    config = prd;
  } else if (hostname.includes('pplpxgpre2.cnsuning.com')) {
    config = pre2;
  } else if (hostname.includes('pplpxgpre.cnsuning.com')) {
    config = pre;
  } else if (hostname.includes('pplpsit.cnsuning.com')) {
    config = sit;
  } else {
    config = pre;
  }
}

const c = config;
c.sit = sit;
c.pre = pre;
c.pre2 = pre2;
c.prd = prd;

export default c;
